import getConfig from 'next/config';

import { createClient } from '@sravni/ugc/lib/client';

import { isServer } from '../../utils/isServer';

const url = isServer ? `${process.env.WEB_PATH}${process.env.API_PATH}` : getConfig().publicRuntimeConfig.apiPath;

export default createClient(url, { sentryErrorTagName: 'home' });
